import clsx from "clsx";
import { twMerge } from "tailwind-merge";

// Interfaces
import { IRenderTagsProps } from "../interfaces";

// Helpers
import { getOptionLabel, getTextTags } from "../utils";

// Layouts
import TooltipText from "@/Layouts/components/Tooltip/TooltipText";

// MUI
import { Chip, Tooltip, Typography } from "@mui/material";

// Icons
import ClearIcon from "@mui/icons-material/Clear";

const getTooltip = (labels = "", hidden = false, hideTooltip = false) => {
	if (!hidden || hideTooltip) {
		return "";
	}
	return <TooltipText text={labels} />;
};

const getChipTagsClasses = (renderTagsCustomProps: { classes?: string } | undefined) => {
	const { classes = "" } = renderTagsCustomProps ?? {};
	return twMerge("!my-[1px] !mr-[3px] !rounded-[4px] !text-[12px] !font-[500] !font-montserrat !text-default", classes);
};

export default function getRenderTags(props: Readonly<IRenderTagsProps>) {
	const {
		tags = [],
		tagsVariant = "",
		selectBy = "_id",
		showBy = "label",
		renderTagsCustomProps = undefined,
		disabled = false,
		hidden = false,
		hideTooltip = false,
		getTagProps = () => {},
	} = props;

	if (tagsVariant === "text") {
		const labels = getTextTags(tags, { selectBy, showBy });
		const tooltip = getTooltip(labels, hidden, hideTooltip);
		return (
			<Tooltip arrow title={tooltip} placement={"top"}>
				<Typography
					noWrap
					className={clsx({
						"!font-sans !text-[14.5px] leading-[1.2] w-[95%]": true,
						"!text-default": !disabled,
						"!text-disabled": disabled,
					})}
				>
					{labels}
				</Typography>
			</Tooltip>
		);
	}

	return tags.map((option, index) => {
		const label = getOptionLabel(option, { selectBy, showBy });
		const tagProps = getTagProps({ index }) ?? {};

		return (
			<Chip
				{...tagProps}
				key={`${label}_${index}`}
				deleteIcon={<ClearIcon />}
				label={label}
				size="small"
				className={getChipTagsClasses(renderTagsCustomProps)}
				sx={{
					height: "22px",
					justifyContent: "space-between",
				}}
			/>
		);
	});
}
